export default  function getInitials(name){
    if (!name) return "NA";
    return name
        .split(" ")
        .map(word => word[0])
        .join("")
        .slice(0, 2)
        .toUpperCase();
};